import { Box, Button, Grid } from '@mui/material';
import AppHeader from '@/components/Elements/Header/AppHeader';
import { ReservationUrls } from '../constants/urls';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export const OutPatientFallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('fid');
  const toReservation = () => {
    navigate(`${ReservationUrls.Reservation}?fid=${facilityId}`, { replace: true });
  };

  return (
    <>
      <AppHeader title={'診療メニュー選択'} />
      <Box sx={{ pt: 2 }}>
        <Grid container direction={'row'} justifyContent={'center'} spacing={2} sx={{ mt: 4 }}>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} className="font-bold" xs={12}>
            {'ご選択されたメニューについて'}
          </Grid>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} xs={12}>
            ご選択されたメニューは<br></br>
            お客様の条件に合致しません。
          </Grid>
          <Grid item sx={{ mt: 2 }} textAlign={'center'} xs={12}>
            大変申し訳ございませんが、<br></br>
            別のメニューをご選択してください。
          </Grid>
          <Button
            sx={{
              position: 'absolute',
              mt: 30,
              left: '50%',
              transform: 'translateX(-50%)',
              WebkitTransform: 'translateX(-50%)',
              msTransform: 'translateX(-50%)'
            }}
            className="bg-primary text-white"
            onClick={toReservation}
          >
            メニュー選択へ
          </Button>
        </Grid>
      </Box>
    </>
  );
};
